"use strict";

exports.__esModule = true;
exports.POLLING_INTERVAL = exports.INTERACTION_COOKIE_NAME = exports.INTERACTIONS_BEFORE_FEEDBACK = exports.FEEDBACK_URL = exports.FEEDBACK_COOKIE_NAME = exports.DAYS_BEFORE_FEEDBACK = void 0;
// Plugin values
const POLLING_INTERVAL = 5000;
exports.POLLING_INTERVAL = POLLING_INTERVAL;
const FEEDBACK_COOKIE_NAME = `last_feedback`;
exports.FEEDBACK_COOKIE_NAME = FEEDBACK_COOKIE_NAME;
const DAYS_BEFORE_FEEDBACK = 30;
exports.DAYS_BEFORE_FEEDBACK = DAYS_BEFORE_FEEDBACK;
const INTERACTION_COOKIE_NAME = `interaction_count`;
exports.INTERACTION_COOKIE_NAME = INTERACTION_COOKIE_NAME;
const INTERACTIONS_BEFORE_FEEDBACK = 3;
exports.INTERACTIONS_BEFORE_FEEDBACK = INTERACTIONS_BEFORE_FEEDBACK;
const FEEDBACK_URL = `https://gatsby.dev/zrx`;
exports.FEEDBACK_URL = FEEDBACK_URL;